import { Button, Modal, Alert, Glyphicon } from 'react-bootstrap';
import React from "react";
import { connect } from 'react-redux';
import { change as formValueChange, Field, FieldArray, FormSection, reduxForm, getFormValues } from 'redux-form';
import moment from 'moment';
import { fetchOrderItems as fetchOrderItemsAction } from '../../actions/orderItems';
import { getUserByPhone as checkCustomerAction } from '../../actions/customers';
import { taxiClasses } from '../../constants/taxiClasses';

import { getAvailablePickupDate, getAvailableOffloadDate } from '../../actions/orders';
import 'react-widgets/dist/css/react-widgets.css';
import 'bootstrap/dist/css/bootstrap.css';
import { DropdownListField, ColorInput } from '../common/Inputs';
import { fetchAddresses as fetchAddressesAction } from '../../actions/addresses';
import { getSettings as getSettingsAction } from '../../actions/settings';
import { AddressEdit } from '../common/AddressEdit';
import EditItemRow from './items/EditItemRow';
import DateTimeField from './DateTimePicker';

import * as fetchingState from '../../constants/fetchingState';
import { getDepartmentTypeById, FACTORY } from '../../constants/dcDepartmentTypes';
import { states, operatorEditStates, INIT as initOrderState, ON_RECEIVING_POINT as onReceivingPointOrderState, defaultHighlightColor, presetHighlightColors } from '../../constants/orderStates';

import { fetchServices as fetchServicesAction } from "../../actions/services";
import { UnstyledPhoneInput } from '../common/PhoneInput';
import { parsePhoneNumber } from '../../extensions/phoneHelper';
import * as settingTypes from '../../constants/settingTypes';
import OrderTotal from './items/OrderTotal';
import SpecialOrderConfirmModal from './SpecialOrderConfirmModal';
import * as permissions from '../../constants/permissions';

const formName = 'orderCreate';
const onChange = (values, dispatch, props, prevValues) => {
    const maxCleaningTime = values.Items.filter(i => i.Service).map(i => i.Service.CleaningTime).sort().pop();
    const prevMaxCleaningTime = prevValues.Items.filter(i => i.Service).map(i => i.Service.CleaningTime).sort().pop();
    if (values.PickupDatePart !== prevValues.PickupDatePart || values.PickupTime !== prevValues.PickupTime || maxCleaningTime !== prevMaxCleaningTime) {
        dispatch(getAvailableOffloadDate({ PickupDate: normalizeDate(values.PickupDatePart, values.PickupTime), ServiceIds: values.Items.filter(i => i.Service).map(i => i.Service.Id) }));
        props.formValueChange(formName, 'OffloadDatePart', null);
        props.formValueChange(formName, 'OffloadTime', null);
    }
}
const validate = ({ Items, PickupDate, OffloadDate, PickupAddress, State, AddressError }) => {

    if (Items === undefined)
        return;
    const errors = {};
    if (Items.some(i => i.ServiceId === 0 && typeof (i.Service) === 'undefined')) {
        errors._error = '*Не выбраны услуги';
    }
    if (Items.some(i => typeof (i.Amount) === 'undefined' || i.Amount < 1)) {
        errors._error = errors._error ? `${errors._error} *Не введено количество` : '*Не введено количество';
    }
    if (State === states.find(s => s.Id === 2) || State === 2) {
        const acceptErrors = validateAcceptedOrder(Items, PickupAddress, PickupDate);
        errors._error = errors._error ? `${errors._error} ${acceptErrors}` : acceptErrors;
    }
    if (PickupDate && PickupDate < new Date())
        errors.PickupDate = '*Нельзя сделать заказ в прошлом';
    if (OffloadDate && OffloadDate < new Date())
        errors.OffloadDate = '*Нельзя сделать заказ в прошлом';
    if (AddressError)
        errors.PickupAddress = { Address: AddressError };

    return errors;
}
const validateAcceptedOrder = (Items, PickupAddress, PickupDate) => {
    let errors = undefined;
    if (typeof (Items) === 'undefined' || (typeof (Items) !== 'undefined' && Items.length === 0)) {
        errors = '*Не выбрано ни одной услуги';
    }
    if (typeof (PickupAddress) === 'undefined' || typeof (PickupAddress.Address) === 'undefined' || PickupAddress.Address === '' ||
        typeof (PickupAddress.GeoAddress) === undefined || typeof (PickupAddress.GeoAddress.X) === 'undefined' || typeof (PickupAddress.GeoAddress.Y) === 'undefined' ||
        PickupAddress.GeoAddress.X === 0 || PickupAddress.GeoAddress.Y === 0) {
        errors = errors ? `${errors} *Не выбран адрес` : '*Не выбран адрес';
    }
    if (PickupDate == null) {
        errors = errors ? `${errors} *Не выбрано когда забрать` : '*Не выбрано когда забрать';
    }
    return errors;
}
const getOperatorOrderStates = (currentState) => {
    let operatorOrderStates = [...states.filter(s => operatorEditStates.some(oes => oes === s.Id))];
    if (!operatorOrderStates.some(oes => oes.Id === currentState))
        operatorOrderStates = [...operatorOrderStates, ...states.filter(s => s.Id === currentState)];

    return operatorOrderStates;
};
const normalizeDate = (date, time) => {
    if (time === 'now')
        return moment();
    return date && time ? moment(date).add(time, 'hours').add((new Date().getTimezoneOffset()), 'minutes') : undefined;
}

let Create = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: props.initialValues,
            initialAddress: props.initialValues.PickupAddress,
            TotalOrderSum: 'Итог 0 р.',
            isSpecialDelivery: false,
            specialDeliveryModalShown: false
        };
        this._handleSubmit = this._handleSubmit.bind(this);
        this._onCheckClick = this._onCheckClick.bind(this);
        this._onSpecialDeliveryCanceled = this._onSpecialDeliveryCanceled.bind(this);
        this._onSpecialDeliveryConfirmed = this._onSpecialDeliveryConfirmed.bind(this);
        this._showSpecialDeliveryModal = this._showSpecialDeliveryModal.bind(this);
    }
    _onCheckClick(values) {
        const { checkCustomerAction } = this.props;
        checkCustomerAction({ phone: parsePhoneNumber(values.Phone) });
    }

    _handleSubmit(values) {
        const { onSubmit } = this.props;

        values.State = undefined;
        values.Phone = parsePhoneNumber(values.Phone);

        const items = values.Items.length > 0 ? values.Items.map(i => ({ ServiceId: i.Service.Id, Amount: i.Amount })) : [];

        const discount = values.Discount == null || values.Discount === '' ? 0 : values.Discount;
        
        const pickupDate = values.PickupDate ? moment(values.PickupDate, 'DD.MM.YYYY HH:mm') : undefined;
        const offloadDate = values.OffloadDate ? moment(values.OffloadDate, 'DD.MM.YYYY HH:mm') : undefined;


        onSubmit({
            PickupAddress: values.PickupAddress,
            PickupDate: pickupDate,
            OffloadDate: offloadDate,
            Phone: values.Phone,
            Items: items,
            PickupTaxiClass: typeof (values.PickupTaxiClass.Id) === 'undefined' ? taxiClasses.Express : values.PickupTaxiClass.Id,
            OffloadTaxiClass: typeof (values.OffloadTaxiClass.Id) === 'undefined' ? taxiClasses.Express : values.OffloadTaxiClass.Id,
            DryCleaningDepartmentId: values.DryCleaningDepartmentId && values.DryCleaningDepartmentId.value ? values.DryCleaningDepartmentId.value : values.DryCleaningDepartmentId,
            Discount: discount,
            IsPickupNow: values.IsPickupNow,
            Comment: values.Comment,
            HighlightColor: values.HighlightColor ? values.HighlightColor : defaultHighlightColor
        });
    }

    getDeliveryDate(isNowSelected, isDateChanged, worktimeList, initialDate, valuesIndex) {
        const date = {};
        date.WorkTimeList = worktimeList ? worktimeList : [];
        if (isNowSelected) {
            date.WorkTimeList = [];
            date.IsNow = true;
            return date;
        }
        if (!isDateChanged && initialDate) {
            date.WorkTimeList = [];
            date.UseDefault = true;
        }
        else if (isDateChanged) {
            date.SelectedIndex = valuesIndex;
        }
        else {
            date.WorkTimeList = [];
            date.SelectedIndex = undefined;
        }
        return date;
    }

    componentDidMount() {
        const { fetchServicesAction, serviceFetching, services, delivery, getSettingsAction, getAvailablePickupDate } = this.props;

        if (serviceFetching !== fetchingState.FETCHING || services.length === 0)
            fetchServicesAction({ category: { Id: 0 }, isActive: { Value: true } });

        if (delivery.fetching !== fetchingState.FETCHING || !delivery.data)
            getSettingsAction(settingTypes.delivery);

        getAvailablePickupDate();
        getSettingsAction(settingTypes.departments, 'active');
    }


    _onSpecialDeliveryConfirmed() {
        this.setState({
            specialDeliveryModalShown: false,
            isSpecialDelivery: true
        });
    }

    _showSpecialDeliveryModal() {
        this.setState({
            specialDeliveryModalShown: true
        });
    }

    _onSpecialDeliveryCanceled() {
        this.setState({
            specialDeliveryModalShown: false
        });
    }

    _renderModalBody() {
        const { handleSubmit,
            defaultAddress,
            useDefAddress,
            editLock,
            fetching: updateFetching,
            fetchAddressesAction,
            fetchedAddresses,
            searchFetching,
            service,
            initialValues: order,
            error,
            delivery,
            department,
            isReceptionPoint,
            updateError
        } = this.props;
        const orderStates = getOperatorOrderStates(order.State);
        const formVisible = updateFetching === fetchingState.INITIAL;
        const customerNotFound = searchFetching === fetchingState.FAILED;
        const services = service.map(s => { return { Name: `${s.Name} (${s.Price} р.)`, Id: s.Id, Price: s.Price, CleaningTime: s.CleaningTime } });
        const filtredDepartments = department.data 
            ? isReceptionPoint ? department.data : department.data.filter(d => d.Type == FACTORY)
            : [];
        const departments = filtredDepartments ? filtredDepartments.map(d => ({ name: `${d.FullName}, ${getDepartmentTypeById(d.Type)}, ${d.Address}`, value: d.Id })) : [];
        
        const { specialDeliveryModalShown } = this.state;

        const renderItemFields = fields => (
            <div>
                {fields.fields.map((i, index, fields) => (
                    <EditItemRow
                        item={i}
                        key={`Service-${index}`}
                        index={index}
                        services={services}
                        fields={fields}
                        meta={i.meta}
                        formName={formName} />
                ))}
                <OrderTotal
                    delivery={delivery.data}
                    services={services}
                    formName={formName}
                    hideDelivery={isReceptionPoint} />
                <div style={{ paddingRight: '15px', paddingLeft: '15px' }}>
                    <div className="row">
                        <div className="col-md-6">
                            <Button disabled={editLock} onClick={() => fields.fields.push({
                                Id: 0,
                                Price: 0,
                                Amount: 1,
                                Service: undefined,
                                ServiceId: 0,
                                CleaningTime: 0
                            })}>Добавить услугу</Button>
                        </div>
                    </div>
                </div>
                {error && <span style={{ color: 'red' }}>{error}</span>}
            </div>);
        
        const renderCommonCreateFields = () => {
            return(
                <div>
                    {renderDateTimePicker('Когда забрать', 'Pickup')}
                        <Field name='PickupTaxiClass' component={DropdownListField} data={taxiClasses}
                            valueField="Id" textField="Name" label="Класс такси (забрать заказ)" disabled={editLock} />
                        {renderDateTimePicker('Когда привезти', 'Offload')}
                        <Field name='OffloadTaxiClass' component={DropdownListField} data={taxiClasses}
                            valueField="Id" textField="Name" label="Класс такси (отвезти заказ)" disabled={editLock} />
                </div>
            );
        }

        const renderDateTimePicker = (label, prefix, max, min) => {
            return(
                <div className='row'>
                        <div className='col-md-4'>
                            <span><strong>{label}</strong></span>
                        </div>
                        <div className='col-md-8'>
                            <Field component={DateTimeField} dateTimeFormat='DD.MM.YYYY HH:mm'
                                time={true} max={max} min={min} name={`${prefix}Date`} />
                        </div>
                    </div>
            );
        }

        return (
            <div>
                {formVisible && <form className='form-horizontal' onSubmit={handleSubmit(this._handleSubmit)} onChange={this._onChange}>
                    <div style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                        {
                            <div className="row" style={{ paddingBottom: '15px' }}>
                                <div className="col-md-2">
                                    <div>
                                        <label style={{ marginTop: '5px' }}>Телефон</label>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <Field name='Phone' component={UnstyledPhoneInput} />
                                    {customerNotFound && <span style={{ color: 'red' }}>*Клиент с таким номером не найден</span>}
                                </div>
                                <div className="col-md-3" >
                                    <Button onClick={handleSubmit(this._onCheckClick)}>Найти</Button>
                                </div>
                            </div>
                        }
                    </div>

                    <FormSection name="PickupAddress">
                        <AddressEdit geoAddressName="PickupAddress.GeoAddress" defaultAddress={useDefAddress ? defaultAddress && defaultAddress.Address ? defaultAddress.Address : undefined : undefined} editLock={editLock || isReceptionPoint} change={this.props.change} fetchAddressesAction={fetchAddressesAction} fetchedAddresses={fetchedAddresses} />
                    </FormSection>

                    <div style={{ paddingRight: '15px', paddingLeft: '15px' }}>
                        <Field name='State' component={DropdownListField} data={orderStates}
                            valueField='Id' textField='Name' label='Статус' disabled={true} def={isReceptionPoint ? onReceivingPointOrderState : initOrderState} />
                        {!isReceptionPoint && renderCommonCreateFields()}
                        <Field name="DryCleaningDepartmentId" component={DropdownListField} label={isReceptionPoint ? 'Точка приема' : 'Тип отдела'} valueField="value" textField="name"
                            disabled={editLock || isReceptionPoint} data={departments} normalize={(value) => value && value.value ? value.value : value} />
                        {!isReceptionPoint && <Field component={ColorInput} label='Цвет' name='HighlightColor' colors={presetHighlightColors} disabled={editLock || isReceptionPoint} />}

                        <SpecialOrderConfirmModal
                            title="Причина экстренной доставки"
                            onConfirmed={this._onSpecialDeliveryConfirmed}
                            onCanceled={this._onSpecialDeliveryCanceled}
                            show={specialDeliveryModalShown}
                            formName={formName} />

                    </div>

                    <FieldArray name='Items' component={renderItemFields} />

                </form>}
                {updateFetching === fetchingState.FETCHING &&
                    <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                {updateFetching === fetchingState.FETCHED &&
                    <Alert bsStyle='success'>УСПЕХ!</Alert>}
                {updateFetching === fetchingState.FAILED &&
                    <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {updateError && <p>{updateError}</p>}
                    </Alert>}
            </div>
        );
    }

    render() {
        const { onClose, editLock, handleSubmit, fetching: updateFetching } = this.props;
        const closeButtonVisible = updateFetching === fetchingState.FETCHED || updateFetching === fetchingState.FAILED;
        const formVisible = updateFetching === fetchingState.INITIAL;
        const isSpecialDeliveryAwailable = permissions.isAllowedFor(permissions.allowedSpecialDelivery);

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Создание заказа</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this._renderModalBody()}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    {isSpecialDeliveryAwailable && (!this.state.isSpecialDelivery ?
                        <Button style={{ float: 'left' }} onClick={this._showSpecialDeliveryModal} >Аварийная доставка</Button>
                        : <div style={{ float: 'left', color: 'green', padding: '6px 12px' }}>
                            <span>Аварийная доставка <Glyphicon glyph='ok-circle' /></span>
                        </div>)}
                    <Button disabled={editLock} bsStyle="success" type="submit" onClick={handleSubmit(this._handleSubmit)}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

Create = reduxForm({
    form: formName,
    validate,
    onChange
})(Create);

function mapToProps(state, props) {
    const isReceptionPoint = permissions.getRole() == permissions.RECEPTION_POINT;
    const customerExists = state.application.get('customerExists');
    const searchResult = customerExists.get('customerExists');
    const searchFetching = customerExists.get('fetching');
    const editLock = ((typeof (searchResult) === 'undefined' || searchResult === false)) ? true : false;
    const customer = customerExists.get('customer');
    const customerAddress = customer ? customer.Address : undefined;
    const auth = state.application.get('auth')
    const receptionPointAddress = auth && auth.get('user') && auth.get('user').get('Address') ? auth.get('user').get('Address') : undefined;
    const authDepartment = auth && auth.get('user') && auth.get('user').get('Department') ? auth.get('user').get('Department') : undefined;
    const defaultAddress = isReceptionPoint ? receptionPointAddress : customerAddress;
    const defaultDepartment = isReceptionPoint ? authDepartment : undefined;
    let useDefAddress = false;
    
    if ((searchFetching === fetchingState.FETCHING || searchFetching === fetchingState.FAILED)) {
        props.initialValues.PickupAddress = undefined;
        state.form.orderCreate.values.PickupAddress = undefined;
        state.form.orderCreate.values.DryCleaningDepartmentId = undefined;
    }
    if (defaultAddress !== undefined && props.initialValues.PickupAddress === undefined) {
        useDefAddress = true;
        props.initialValues.PickupAddress = defaultAddress;
        state.form.orderCreate.values.PickupAddress = defaultAddress;
        state.form.orderCreate.values.DryCleaningDepartmentId = defaultDepartment ? {name: defaultDepartment.FullName, value: defaultDepartment.Id} : null;
    }
    const service = state.application.get('serviceCategory').get('service');
    const fetchedAddresses = state.application.get('addresses');
    const delivery = state.application.get('settings')[settingTypes.delivery];
    const formValues = getFormValues(formName)(state);
    const department = state.application.get('settings')[settingTypes.departments];
    const updateError = state.application.get('orders').get('updateError');

    return {
        service: service.services,
        serviceFetching: service.fetching,
        editLock: editLock,
        searchFetching: searchFetching,
        defaultAddress: defaultAddress,
        useDefAddress: useDefAddress,
        fetchedAddresses: fetchedAddresses,
        delivery,
        pickupDatePart: formValues ? formValues.PickupDatePart : undefined,
        department,
        isReceptionPoint,
        updateError
    }
}

Create = connect(mapToProps, {
    fetchOrderItemsAction,
    fetchServicesAction,
    checkCustomerAction,
    fetchAddressesAction,
    getSettingsAction,
    getAvailableOffloadDate,
    getAvailablePickupDate,
    formValueChange
})(Create);

export default Create;


// WEBPACK FOOTER //
// ./src/components/orders/Create.jsx